import React, { useEffect } from 'react'
import { TextField as InputField } from '@material-ui/core'
import moment from 'moment'

import { translate } from 'locales'

// Styles
import { Title, TextArea } from 'components'
import useStorage from 'hooks/storageSync'
import * as S from './styles'

const Anamnese: React.FunctionComponent<{
  doctorName: string
  scheduleId: string
  medicalRecord: any
  symptoms: string
}> = ({ doctorName, scheduleId, medicalRecord, symptoms }) => {
  const [storage, setStorage, setAllStorage]: any = useStorage(
    scheduleId,
    'anamnese'
  )

  const dataStorage: any = storage?.anamnese

  const handleChange = (key: string, e: string) => {
    setStorage(key, e)
  }

  useEffect(() => {
    if (medicalRecord) {
      const data = {
        ...storage,
        ['anamnese']: {
          ...storage?.['anamnese'],
        },
      }

      setAllStorage(data)
    }
  }, [medicalRecord])

  return (
    <S.SectionContent>
      <span>{moment(new Date()).format('dddd, DD/MM/YYYY')}</span>
      <p>{`${translate('medicalRecord.by')} ${doctorName}`}</p>
      <div className="subsection">
        <Title text="Anamnese" />
        <div className="subsection-item">
          <span>{translate('medicalRecord.reason')}</span>
          <h5 style={{ marginTop: '10px', fontSize: '14px' }}>
            {!symptoms ? translate('medicalRecord.uninformed') : symptoms}
          </h5>
        </div>

        <div className="subsection-item">
          <span>{`${translate('medicalRecord.compaint')} *`}</span>
          <TextArea
            value={dataStorage?.complaint}
            name="complaint"
            rows={5}
            wrap="hard"
            onChange={(e: any) => handleChange(e.target.name, e.target.value)}
            placeholder={translate('medicalRecord.describe')}
          />
        </div>

        <div className="subsection-item">
          <span>{`${translate('medicalRecord.historyCurrent')} *`}</span>
          <TextArea
            value={dataStorage?.history}
            name="history"
            rows={5}
            wrap="hard"
            onChange={(e: any) => handleChange(e.target.name, e.target.value)}
            placeholder={translate('medicalRecord.describe')}
          />
        </div>

        <div className="subsection-item">
          <span>{translate('medicalRecord.allergies')}</span>
          {medicalRecord?.medical_allergy_description && (
            <>
              <br />
              <h5>
                {`${translate('medicalRecord.informedByPatient')} ${
                  medicalRecord?.medical_allergy_description
                }`}
              </h5>
            </>
          )}
          <InputField
            color="secondary"
            variant="outlined"
            className="input-default"
            name="allergies"
            type="text"
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            value={dataStorage?.allergies}
            label={false}
            placeholder={translate('medicalRecord.describe')}
          />
        </div>

        {/* <div className="subsection-item">
          <span>Diabetes:</span>
          <RadioGroup
            aria-label="diabete"
            name="diabetes"
            style={{ display: 'flex', flexDirection: 'row' }}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
          >
            <FormControlLabel
              value="sim"
              checked={dataStorage?.diabetes === 'sim'}
              control={<Radio />}
              label="Sim"
            />
            <FormControlLabel
              value="nao"
              checked={dataStorage?.diabetes === 'nao'}
              control={<Radio />}
              label="Não"
            />
          </RadioGroup>
        </div> */}

        <div className="subsection-item">
          <span>{translate('medicalRecord.pathologicalBackground')}</span>
          {/* {medicalRecord?.Medical_record_heath_problem?.length !==
            0 && (
            <>
              <br />
              <h5>
                {`${translate(
                  'medicalRecord.informedByPatient'
                )} ${medicalRecord?.Medical_record_heath_problem?.map(
                  (pat: any) => ` ${pat.name}`
                ).toString()}`}
              </h5>
            </>
          )} */}

          <TextArea
            value={dataStorage?.pathologicalBackground}
            name="pathologicalBackground"
            rows={3}
            wrap="hard"
            onChange={(e: any) => handleChange(e.target.name, e.target.value)}
            placeholder={translate('medicalRecord.describe')}
          />
        </div>

        <div className="subsection-item">
          <span>{translate('medicalRecord.continuousRemedy')}</span>
          {medicalRecord?.continuous_remedy && (
            <>
              <br />
              <h5>
                {`${translate('medicalRecord.informedByPatient')} ${
                  medicalRecord?.continuous_remedy
                }`}
              </h5>
            </>
          )}
          <TextArea
            value={dataStorage?.continuousRemedy}
            name="continuousRemedy"
            rows={3}
            wrap="hard"
            onChange={(e: any) => handleChange(e.target.name, e.target.value)}
            placeholder={translate('medicalRecord.describe')}
          />
        </div>
      </div>
    </S.SectionContent>
  )
}

export default Anamnese
